import React from 'react'
import { connect } from 'react-redux'
import { Button, Form, FormGroup } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import Immutable from 'immutable'
import PropTypes from 'prop-types'
import FormItem from '../../../common/forms/FormItem'
import TextInput from '../../../common/forms/input/TextInput'
import { isRequired } from '../../../../utils/validators'

const RoadBookingDiscountCodeForm = ({ handleSubmit, discountCode }) => {

  const isApplyDiscount = !discountCode.isEmpty();

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup className='road-booking discount-code-form' >
        <FormItem label="Código de Descuento" labelSmWidth={12} itemSmWidth={12} >
          <Field
            name="discountCode"
            component={TextInput}
            type="text"
            placeholder="Ingrese su código de descuento"
            validate={
              isApplyDiscount ? [] : [isRequired]
            }
            append={<Button color={isApplyDiscount ? "danger" : "primary"} type="submit">{isApplyDiscount ? "Quitar" : "Aplicar"}</Button>}
          />
        </FormItem>
      </FormGroup>
    </Form>
  )
}

RoadBookingDiscountCodeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  discountCode: PropTypes.instanceOf(Immutable.Map).isRequired,
}

const mapStateToProps = ({ BookingUnit }) => ({
  discountCode: BookingUnit.Booking.getIn(['roadBooking', 'discount']),
})

const form = reduxForm({
  form: 'roadBookingDiscountCodeForm',
})(RoadBookingDiscountCodeForm)

export default connect(mapStateToProps)(form)
